<template>
    <div class="sidebar-warrper">
        <div class="left-nav bg-shadow">
            <div class="logoWarp">
                <img src="../../../static/img/MA LOGO.png" width="90" height="32"/>
            </div>
            <el-scrollbar wrap-class="scrollbar-wrapper">
                <div class="side-nav">
                    <el-menu
                            ref="sideMenu"
                            :unique-opened="true"
                            :default-active="activeMenu"
                            class="el-menu-vertical-demo"
                            @select="handleMenuSelect">
                        <div v-for="(item) in list" :key="item.path">
                            <el-submenu :index="item.path" v-if="item.meta.hasChildrenMenu">
                                <template slot="title">
                                    <i :class="['iconfont', item.meta.icon]"></i>
                                    <!--<img :src="require('../../../static/img/'+item.meta.icon)" class="menu-icon">-->
                                    <span style="margin-left: 11px;">{{item.meta.title}}</span>
                                </template>
                                
                                <el-menu-item :index="resolvePath(item.path+'/'+child.path)"
                                              v-for="(child) in item.children"
                                              v-if="!(child.children&&child.children.length>0)"
                                              :key="item.path+'/'+child.path" class="sub-menu-item">
                                              <template>
                                                 {{child.meta.title}}
                                                <div v-if="child.newDevelop" class="newFun">
                                                    <div>
                                                        New
                                                    </div>
                                                </div>
                                              </template>
                                           
                                </el-menu-item>
                                <el-submenu v-for="(child,ind) in item.children"
                                            v-if="child.children&&child.children.length>0"
                                            :key="ind"
                                            :index="resolvePath(item.path+'/'+child.path)"
                                >
                                    <template slot="title">
                                        <svg  v-if="child.meta.colorIcon" class="icon" aria-hidden="true">
                                            <use :xlink:href="child.meta.colorIcon"></use>
                                        </svg>
                                        <i v-else-if="child.meta.icon" :class="['iconfont', child.meta.icon]" ></i>
                                        <!--<img v-if="child.meta.icon" :src="require('../../../static/img/'+child.meta.icon)" class="menu-icon">-->
                                        <span style="margin-left: 11px;">{{child.meta.title}}</span>
                                    </template>
                                    <el-menu-item :index="resolvePath(item.path+'/'+child.path+'/'+im.path)" v-for="im in child.children"
                                                  :key="child.path+'/'+im.path" class="sub-menu-item">
                                        {{im.meta.title}}
                                        <div v-if="im.newDevelop" class="newFun">
                                            <div>
                                                New
                                            </div>
                                        </div>
                                    </el-menu-item>
                                </el-submenu>
                            </el-submenu>
                            <el-menu-item
                                    v-else
                                    :index="resolvePath(item.path)">
                                <!-- <i :class="['iconfont', item.meta.icon]"></i> -->

                                 <svg  v-if="item.meta.colorIcon" class="icon" aria-hidden="true">
                                        <use :xlink:href="item.meta.colorIcon"></use>
                                    </svg>
                                    <i v-else-if="item.meta.icon" :class="['iconfont', item.meta.icon]" ></i>
                                <!--<img :src="require('../../../static/img/'+item.meta.icon)" class="menu-icon">-->
                                <!--<i :class="item.meta.icon"></i>-->
                                <span slot="title" style="margin-left: 11px;">{{item.meta.title}}</span>
                            </el-menu-item>
                        </div>
                    </el-menu>
                </div>
            </el-scrollbar>
        </div>
    </div>
</template>

<script>
    import sideBarJs from './sideBar.js'

    export default sideBarJs
</script>

<style lang="scss" scoped>
    @import "sideBar";
</style>




// WEBPACK FOOTER //
// src/layout/sideBar/sideBar.vue